import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { apiBaseUrl } from 'lib.shared/src/api';

/** What the unsubscribe page shows for its token */
export interface MailingUnsubscribe {
  /** masked — the page is open to whoever holds the link */
  email: string | null;
  event_name: string | null;
  is_unsubscribed: boolean;
  /** a test mail's link: it unsubscribes no one */
  is_test: boolean;
}

/**
 * A mailing's own unsubscribe, public: the signed token in the link is the
 * authority, so a 401 must never send anyone to the login page.
 */
export const mailingUnsubscribeApi = createApi({
  reducerPath: 'mailing_unsubscribe',
  baseQuery: fetchBaseQuery({ baseUrl: apiBaseUrl }),
  tagTypes: ['mailing_unsubscribe'],
  endpoints: (build) => ({
    getMailingUnsubscribe: build.query<{ data: MailingUnsubscribe }, { token: string }>({
      query: ({ token }) => ({
        url: `/mailings/unsubscribe/${encodeURIComponent(token)}`,
        headers: { Accept: 'application/json' },
      }),
    }),
    unsubscribeMailing: build.mutation<{ data: MailingUnsubscribe }, { token: string }>({
      query: ({ token }) => ({
        url: `/mailings/unsubscribe/${encodeURIComponent(token)}`,
        method: 'POST',
        headers: { Accept: 'application/json' },
      }),
    }),
  }),
});

export const { useGetMailingUnsubscribeQuery, useUnsubscribeMailingMutation } =
  mailingUnsubscribeApi;
